import AmexSecurityCenterKeepAccountSafe from './AmexSecurityCenterKeepAccountSafe';

export default AmexSecurityCenterKeepAccountSafe;
